/*category*/
/*END*/

/*action*/
    export const VIDEOCALL_TO_DOCTOR = 'videocall-to-doctor'
    export const VRITE_TO_DOCTOR = 'vrite-to-doctor'
/*END*/

/* Label */
    export const HEADER_BUTTON = 'header-button'
    export const MID_BUTTON = 'mid-button'
    export const FOOTER_BUTTON = 'footer-button'
/*END*/